/**
 * 로그인 여부를 **판정하지 못한** 상태 화면.
 *
 * 세션이 만료된 것(4xx)과 서버가 흔들린 것(5xx·네트워크)은 다르다. 후자를 로그인
 * 만료로 처리하면 사용자는 멀쩡한 세션으로 로그인 화면에 튕기고, 다시 로그인하면
 * 아무 일 없다는 듯 동작한다 — "이유 없이 로그아웃된다"는 신고의 전형적인 정체다.
 * 그래서 여기서는 세션을 버리지 않고 재시도만 제안한다.
 */
export function SessionUnavailable({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <div className="flex flex-col items-center gap-4 text-center">
        <p className="text-base font-medium text-slate-700">
          로그인 상태를 확인하지 못했습니다.
        </p>
        <p className="text-sm text-slate-400">
          서버에 일시적인 문제가 있을 수 있습니다. 잠시 후 다시 시도해주세요.
        </p>
        <button
          type="button"
          onClick={onRetry}
          className="rounded-md bg-primary px-4 py-2 text-sm text-white hover:opacity-90"
        >
          다시 시도
        </button>
      </div>
    </div>
  );
}
